<template>
  <!-- See ui/src/scss/base/helpers.scss -->
  <div class="upper-header container">
    <div class="inner-container edged-centered-space-evenly-flexbox">
      <div class="top-menu hidden-on-mobile">
        <ul v-if="isLoggedIn">
          <li>
            <a href="/account">Account</a>
          </li>
        </ul>

        <ul v-else>
          <li>
            <a href="/account/login">Login</a>
          </li>
          <li>
            <a href="/account/register">Register</a>
          </li>
        </ul>

        <div
          class="caption edged-centered-space-evenly-flexbox make-flex-start make-align-normal currency-converter-container"
        >
          <CurrencyConvertor />
          <RegionDropdown />
        </div>
        <div></div>
      </div>

      <BrandLogo icon-name="I.AM.GIA" width="251px" height="45px" view-box="0 0 251 45">
        <Logo />
      </BrandLogo>

      <div class="top-menu">
        <ul>
          <li class="hide-mobile">
            <a href="/pages/wishlist">
              Wishlist
              <span class="slash">/</span>
              <span class="wishListCounterID">{{ wishlistCount }}</span>
            </a>
          </li>
          <li class="my-bag hide-tablet hide-mobile">
            <a href="#" @click="showCart">
              My Bag
              <span class="slash">/</span>
              <span class="CartCount">{{ cartCount }}</span>
            </a>
          </li>
          <li class="my-bag hide-desktop hide-big-tablet">
            <a href="/cart">
              My Bag
              <span class="slash">/</span>
              <span class="CartCount">{{ cartCount }}</span>
            </a>
          </li>
        </ul>
      </div>

      <slot />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ProcessLiquid from '../../mixins/ProcessLiquid.js'
import BrandLogo from '../atoms/BrandLogo.vue'
import Logo from '../atoms/Logo.vue'
import CurrencyConvertor from '../atoms/CurrencyConvertor.vue'
import RegionDropdown from '../atoms/RegionDropdown.vue'

export default {
  mixins: [ProcessLiquid],
  data: () => ({
    links: 'liquid:linklists.main-menu',
  }),
  computed: mapGetters(['isLoggedIn', 'wishlistCount', 'cartCount']),
  components: {
    BrandLogo,
    Logo,
    CurrencyConvertor,
    RegionDropdown,
  },
  methods: {
    showCart() {
      this.$store.commit('showCart')
      return this.$store.state.cart.cartFlag
    },
  },
}
</script>
